import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PAYMENT_PATHNAME } from './constants';

const StarterUpgrade = React.lazy(() =>
  import(/* webpackChunkName: "StarterUpgrade" */ 'screens/StarterUpgrade')
);

const OrderConfirmation = React.lazy(() =>
  import(
    /* webpackChunkName: "OrderConfirmation" */ 'screens/OrderConfirmation'
  )
);

const TrialsPage = React.lazy(() =>
  import(/* webpackChunkName: "TrialsPage" */ 'screens/Trials')
);

const NoAccess = React.lazy(() =>
  import(/* webpackChunkName: "NoAccess" */ 'screens/NoAccess')
);

const NotFound = React.lazy(() =>
  import(/* webpackChunkName: "NotFound" */ 'screens/NotFound')
);

const PricingPackaging = React.lazy(() =>
  import(/* webpackChunkName: "NotFound" */ 'screens/PricingPackaging')
);

const PricingPackagingReadOnly = React.lazy(() =>
  import(
    /* webpackChunkName: "PricingPackagingReadOnly" */ 'screens/PricingPackagingReadOnly'
  )
);

const FeaturesReadOnly = React.lazy(() =>
  import(/* webpackChunkName: "FeaturesReadOnly" */ 'screens/FeaturesReadOnly')
);

const SelectPlanCheckout = React.lazy(() =>
  import(
    /* webpackChunkName: "SelectPlanCheckout" */ 'screens/SelectPlanCheckout'
  )
);

const DormantPage = React.lazy(() =>
  import(/* webpackChunkName: "DormantPage" */ 'screens/Dormant')
);

const RoutesComponent = () => {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<StarterUpgrade />} path={PAYMENT_PATHNAME} />
          <Route element={<OrderConfirmation />} path="/confirmation/:plan" />
          <Route element={<DormantPage />} path="/dormant" />
          <Route element={<SelectPlanCheckout />} path="/plans/*" />
          <Route element={<TrialsPage />} path="/trials/*" />
          <Route element={<PricingPackaging />} path="/pricing" />
          <Route element={<PricingPackagingReadOnly />} path="/pricing-view" />
          <Route element={<FeaturesReadOnly />} path="/features-view" />

          <Route element={<NoAccess />} path="/no-access" />
          <Route element={<NotFound />} path="*" />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RoutesComponent;
